import { useState } from 'react';

import { Chip } from 'shared/mui/Chips';
import { UserRoleValue } from 'types/embedded/user';

const DEFAULT_ICON = '/default.svg';

type Props = {
  roleValue: UserRoleValue;
};

export const UserRoleChip: React.FC<Props> = ({ roleValue }) => {
  const [src, setSrc] = useState(roleValue?.icon || DEFAULT_ICON);
  return (
    <Chip
      icon={
        <img
          alt="icon"
          onError={() => {
            setSrc(DEFAULT_ICON);
          }}
          src={src}
        />
      }
      label={roleValue?.role}
    />
  );
};
